import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Intro',
  setup: function setup(__props) {
    var step = ref(1);
    return {
      __sfc: true,
      step: step
    };
  }
});